// Import service types
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
// Import functions
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import itemId from 'owa-service/lib/factory/itemId';
import itemChange from 'owa-service/lib/factory/itemChange';
import createSetItemField from './utils/createSetItemField';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
function createRequestBody(messageType, isSend, IRMData) {
    var updates = [
        createSetItemField('ToRecipients', messageType.ToRecipients),
        createSetItemField('CcRecipients', messageType.CcRecipients),
        createSetItemField('BccRecipients', messageType.BccRecipients),
        createSetItemField('Subject', messageType.Subject),
        createSetItemField('Body', messageType.Body),
        createSetItemField('Importance', messageType.Importance),
    ];
    if (messageType.From) {
        updates.push(createSetItemField('From', messageType.From));
    }
    if (messageType.MentionsEx) {
        updates.push(createSetItemField('MentionsEx', messageType.MentionsEx));
    }
    var itemChanges = itemChange({
        Updates: updates,
        ItemId: itemId({
            Id: messageType.ItemId.Id,
            ChangeKey: messageType.ItemId.ChangeKey,
        }),
    });
    var request = updateItemRequest({
        ItemChanges: [itemChanges],
        ConflictResolution: 'AlwaysOverwrite',
        ClientSupportsIrm: true,
        SendCalendarInvitationsOrCancellations: 'SendToNone',
        MessageDisposition: isSend ? 'SendAndSaveCopy' : 'SaveOnly',
        SuppressReadReceipts: false,
        ComposeOperation: 'newMail',
        OutboundCharset: 'AutoDetect',
        PromoteInlineAttachments: false,
        SendOnNotFoundError: true,
        ItemShape: itemResponseShape({
            // Pass IdOnly as ShapeName here so that the response will contain LastModifiedTime
            BaseShape: 'IdOnly',
            AdditionalProperties: [propertyUri({ FieldURI: 'ItemLastModifiedTime' })],
        }),
    });
    if (IRMData && IRMData.IsOwner) {
        // If no encryption, need to explicitly set complianceId to '0' to remove any pre set IRM state
        request.ComplianceId = IRMData.RmsTemplateId ? IRMData.RmsTemplateId.toUpperCase() : '0';
    }
    return request;
}
export default function sendOrSaveMessageService(itemType, isSend, IRMData) {
    var requestBody = createRequestBody(itemType, isSend, IRMData);
    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response
            ? Promise.resolve(response.Body)
            : Promise.reject(new Error('ErrorSessionTimeout')); // When get HTTP 401/440, the response will be null
    });
}
//# sourceMappingURL=sendOrSaveMessageService.js.map